// extracted by mini-css-extract-plugin
export default {"root":"NewNotificationDisplay_root__N8WPA","newNotification":"NewNotificationDisplay_newNotification__dAsD1","dismissButton":"NewNotificationDisplay_dismissButton__6ft3-"};